import { render, staticRenderFns } from "./CrmAnexarLaudoExterno.vue?vue&type=template&id=214c6a54&"
import script from "./CrmAnexarLaudoExterno.vue?vue&type=script&lang=js&"
export * from "./CrmAnexarLaudoExterno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports